export default "__VITE_ASSET__p63WbBUQ__"